import axios from "axios";
import config from "@/config/constants.js";
import {firebase, firestore} from "@/config/firebase";

if (localStorage.getItem('auth_token')) {
  axios.defaults.headers.common['Authorization'] = localStorage.getItem('auth_token');
}

export default {
  namespaced: true,
  state: {
    status: "",
    status_list: "",
  },
  user: JSON.parse(localStorage.getItem(config.token_key)) || '',
  mutations: {
    loading(state) {
      state.status = "loading";
    },
    success(state) {
      state.status = "";
    },
    status(state, status) {
      state.status = status;
    },
    status_list(state, status) {
      state.status_list = status;
    },
  },
  actions: {
    async delete_account({commit}) {
      commit('status_list', 'loading');
      await axios.put(config.api_url + 'delete_account');
      commit('status_list', '');
    },
    update_info_company: async function ({commit}, data) {
      commit('loading');
      //change company name
      if (data.company_name !== data.company_name_current) {
        // await firestore.collection('users').doc(data.owner_id).set({
        //     company_name: data.company_name
        // },{merge: true});

        let tenantUsersRef = await firestore.collection("tenants").doc(data.tenant_id).collection("users").where('user_role', 'in', ['owner', 'agent']).get();
        for (const tenantUser of tenantUsersRef.docs) {
          await firestore.collection("tenants").doc(data.tenant_id).collection("users")
            .doc(tenantUser.id).set({company_name: data.company_name}, {merge: true});
        }
        // eslint-disable-next-line no-await-in-loop
        let usersRef = await firestore.collection("users").where('tenant_ids', 'array-contains', data.tenant_id).get();
        for (const doc of usersRef.docs) {
          let info = doc.data();

          let tenants_list = [];

          for (const tenant of info.tenants_list) {
            if (tenant.tenant_id === data.tenant_id) {
              tenant['company_name'] = data.company_name
            }
            tenants_list.push(tenant);
          }
          // eslint-disable-next-line no-await-in-loop
          await firestore.collection("users").doc(doc.id).set({tenants_list: tenants_list}, {merge: true});
        }

        await firestore.collection('tenants').doc(data.tenant_id).set({
          company_name: data.company_name
        }, {merge: true});

      }
      //Save email and address (always, regardless of phone number change)
      await firestore.collection('users').doc(data.owner_id).set({
        email: data.email,
        address: data.address
      }, {merge: true});

      const tenantAddressUpdate = { address: data.address };
      // Only include location when the user picked a place from the
      // autocomplete dropdown this session — a freeform-text save would
      // leave `location` as null and overwrite the real coordinates.
      if (data.location && typeof data.location.lat === 'number' && typeof data.location.lng === 'number') {
        tenantAddressUpdate.location = data.location;
      }
      await firestore.collection('tenants').doc(data.tenant_id).set(
        tenantAddressUpdate,
        {merge: true}
      );

      //Updating new phone number if changed
      data.new_phone_number = config.phone_extension + data.new_phone_number;

      if (firebase.auth().currentUser.phoneNumber !== data.new_phone_number) {
        try {
          await axios.post(config.api_url + 'web/updateUser', {
            new_phone_number: data.new_phone_number,
            user_current: firebase.auth().currentUser
          });

          await firestore.collection('users').doc(data.owner_id).set({
            phone_number: data.new_phone_number,
            device_tokens: []
          }, {merge: true});

          let queryDevices = await firestore.collection('devices').where("owner_id", "==", data.owner_id).get();
          // eslint-disable-next-line no-await-in-loop
          await queryDevices.forEach(async doc => {
            await config.db.collection("devices").doc(doc.id).delete();
          });

          //To Update Referrals, Chats, Rooms
          let tenants = data.user.tenants_list;
          for (const tenant of tenants) {
            let path = '/tenants/' + tenant.tenant_id + '/users/' + data.owner_id;
            // eslint-disable-next-line no-await-in-loop
            let queryChats = await firestore.collection('tenants').doc(tenant.tenant_id).collection('chats').where("participant_ids", "array-contains", path).get();
            for (const chat of queryChats.docs) {
              let participants = [];
              for (const part of chat.data().participants) {
                if (part['user_id'] === data.user.owner_id) {
                  part['phone_number'] = data.new_phone_number
                }
                participants.push(part);
              }
              // eslint-disable-next-line no-await-in-loop
              await firestore.collection('tenants').doc(tenant.tenant_id).collection('chats').doc(chat.id).set({
                participants: participants
              }, {
                merge: true
              });
            }
            // eslint-disable-next-line no-await-in-loop
            let queryReferrals = await firestore.collection('tenants').doc(tenant.tenant_id).collection('referrals').where("participant_ids", "array-contains", path).get();
            for (const referral of queryReferrals.docs) {
              let participants = [];
              for (const part of referral.data().participants) {
                if (part['user_id'] === data.user.owner_id) {
                  part['phone_number'] = data.new_phone_number
                }
                participants.push(part);
              }
              // eslint-disable-next-line no-await-in-loop
              await firestore.collection('tenants').doc(tenant.tenant_id).collection('referrals').doc(referral.id).set({
                participants: participants
              }, {
                merge: true
              });
            }
          }
        } catch (error) {
          console.error('Phone number update failed:', error);
        }
      }
      commit('success');
    },
    update_info_company_from_vendor: async function ({commit}, data) {
      commit('loading');
      //change company name
      if (data.company_name !== data.company_name_current) {
        await firestore.collection('users').doc(data.owner_id).set({
          company_name: data.company_name
        }, {merge: true});
        if (data.user.user_role === 'vendor') {
          let tenantUsersRef = await firestore.collection("tenants").doc(data.tenant_id).collection("users").where('owner_id', '==', data.owner_id).get();
          for (const tenantUser of tenantUsersRef.docs) {
            // eslint-disable-next-line no-await-in-loop
            await firestore.collection("tenants").doc(data.tenant_id).collection("users")
              .doc(tenantUser.id).set({company_name: data.company_name}, {merge: true});
          }

          let tenantUsersEmployeesRef = await firestore.collection("tenants").doc(data.tenant_id).collection("users").where('vendor_id', '==', data.owner_id).get();
          for (const tenantUserEmployee of tenantUsersEmployeesRef.docs) {
            // eslint-disable-next-line no-await-in-loop
            await firestore.collection("tenants").doc(data.tenant_id).collection("users")
              .doc(tenantUserEmployee.id).set({company_name: data.company_name}, {merge: true});
          }
        }
        if (data.user.user_role === 'employee') {
          let tenantUsersRef = await firestore.collection("tenants").doc(data.tenant_id).collection("users").where('owner_id', '==', data.vendor_id).get();
          for (const tenantUser of tenantUsersRef.docs) {
            // eslint-disable-next-line no-await-in-loop
            await firestore.collection("tenants").doc(data.tenant_id).collection("users")
              .doc(tenantUser.id).set({company_name: data.company_name}, {merge: true});
          }

          let tenantUsersEmployeesRef = await firestore.collection("tenants").doc(data.tenant_id).collection("users").where('vendor_id', '==', data.vendor_id).get();
          for (const tenantUserEmployee of tenantUsersEmployeesRef.docs) {
            // eslint-disable-next-line no-await-in-loop
            await firestore.collection("tenants").doc(data.tenant_id).collection("users")
              .doc(tenantUserEmployee.id).set({company_name: data.company_name}, {merge: true});
          }
        }
      }
      // Save email and address (always, regardless of phone number change)
      await firestore.collection('users').doc(data.owner_id).set({
        email: data.email,
        address: data.address
      }, {merge: true});

      const tenantAddressUpdate = { address: data.address };
      if (data.location && typeof data.location.lat === 'number' && typeof data.location.lng === 'number') {
        tenantAddressUpdate.location = data.location;
      }
      await firestore.collection('tenants').doc(data.tenant_id).set(
        tenantAddressUpdate,
        {merge: true}
      );

      // Updating new phone number if changed
      data.new_phone_number = config.phone_extension + data.new_phone_number;

      if (firebase.auth().currentUser.phoneNumber !== data.new_phone_number) {
        try {
          await axios.post(config.api_url + 'web/updateUser', {
            new_phone_number: data.new_phone_number,
            user_current: firebase.auth().currentUser
          });

          await firestore.collection('users').doc(data.owner_id).set({
            phone_number: data.new_phone_number,
            device_tokens: []
          }, {merge: true});

          let queryDevices = await firestore.collection('devices').where("owner_id", "==", data.owner_id).get();
          for (const doc of queryDevices.docs) {
            // eslint-disable-next-line no-await-in-loop
            await config.db.collection("devices").doc(doc.id).delete();
          }

          // To Update Referrals, Chats, Rooms
          let tenants = data.user.tenants_list;
          for (const tenant of tenants) {
            let path = '/tenants/' + tenant.tenant_id + '/users/' + data.owner_id;
            // eslint-disable-next-line no-await-in-loop
            let queryChats = await firestore.collection('tenants').doc(tenant.tenant_id).collection('chats').where("participant_ids", "array-contains", path).get();
            for (const chat of queryChats.docs) {
              let participants = [];
              for (const part of chat.data().participants) {
                if (part['user_id'] === data.user.owner_id) {
                  part['phone_number'] = data.new_phone_number
                }
                participants.push(part);
              }
              // eslint-disable-next-line no-await-in-loop
              await firestore.collection('tenants').doc(tenant.tenant_id).collection('chats').doc(chat.id).set({
                participants: participants
              }, {
                merge: true
              });
            }
            // eslint-disable-next-line no-await-in-loop
            let queryReferrals = await firestore.collection('tenants').doc(tenant.tenant_id).collection('referrals').where("participant_ids", "array-contains", path).get();
            for (const referral of queryReferrals.docs) {
              let participants = [];
              for (const part of referral.data().participants) {
                if (part['user_id'] === data.user.owner_id) {
                  part['phone_number'] = data.new_phone_number
                }
                participants.push(part);
              }
              // eslint-disable-next-line no-await-in-loop
              await firestore.collection('tenants').doc(tenant.tenant_id).collection('referrals').doc(referral.id).set({
                participants: participants
              }, {
                merge: true
              });
            }
          }
        } catch (error) {
          console.error('Phone number update failed:', error);
        }
      }
      commit('success');
    },
  },
}
